module.exports = __webpack_public_path__ + "img/0.8.9e703531.png";